export const en = {
    'error-title': 'Could not change the title',
    'error-title-validation': 'Validation error',
    'updated-title': 'Updated'
};
